module.exports = __webpack_public_path__ + "static/media/american-football-scores-numbers.62d82ba0.svg";